import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import { MeRes } from 'shared/types/general.types'

export const useFetchMe = () => {
	const axiosPrivate = useAxiosPrivate()
	const { data: me, isSuccess: isMeSuccess } = useQuery<MeRes>({
		queryKey: queryKeys.me.all,
		queryFn: () => axiosPrivate.get(apiRoutes.me)
	})

	return {
		me,
		isMeSuccess
	}
}
